import '../styles/globals.css'
import Head from 'next/head'
import React, { useEffect, useState } from 'react'
import { withTranslation } from 'react-i18next'

import type { AppProps } from 'next/app'

import { MaintenanceDetection } from '@/components/layout'
import { queryClient } from '@/lib/react-query'
import { AppProvider } from '@/providers/app'
import { GoogleAnalyticsProvider } from '@/providers/ga'

if (process.env.NEXT_PUBLIC_API_MOCKING === 'true') {
  require('../test/server/setup')
}

function MyApp({ Component, pageProps }: AppProps) {
  const [title, setTitle] = useState('')

  useEffect(() => {
    fetch('/title.txt')
      .then((res) => res.text())
      .then((text) => setTitle(text.trim()))
      .catch(() => {})
  }, [])

  if (typeof window === 'undefined') return <></>

  const ComponentWithI18n = withTranslation()(Component)
  return (
    <>
      <Head>
        <meta name="robots" content="noindex" />
        <meta
          name="viewport"
          content="width=device-width,initial-scale=1.0,maximum-scale=1.0"
        />
        <title>{title}</title>
        <link rel="apple-touch-icon" href="/apple-touch-icon.png"></link>
      </Head>
      <AppProvider queryClient={queryClient}>
        <GoogleAnalyticsProvider>
          <MaintenanceDetection>
            <ComponentWithI18n {...pageProps} />
          </MaintenanceDetection>
        </GoogleAnalyticsProvider>
      </AppProvider>
    </>
  )
}

export default MyApp
